/*
 * @Author: showVinc
 * @Date: 2019-06-07 16:01:19
 * @Description: file content
 */
import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'Index',
      component: resolve => require(['@/pages/index'], resolve)
    },
    {
      path: '/login',
      name: 'Login',
      component: resolve => require(['@/pages/login'], resolve)
    },
    {
      path: '/drops',
      name: 'Drops',
      component: resolve => require(['@/pages/drops/index'], resolve)
    },
    {
      path: '/drops/detail',
      name: 'DropsDetail',
      component: resolve => require(['@/pages/drops/detail'], resolve)
    },
    {
      path: '/drops/draw',
      name: 'DropsDraw',
      component: resolve => require(['@/pages/drops/draw'], resolve)
    },
    {
      path: '/drops/open',
      name: 'DropsOpen',
      component: resolve => require(['@/pages/drops/open'], resolve)
    },
    {
      path: '/discover',
      name: 'Discover',
      component: resolve => require(['@/pages/discover/index'], resolve)
    },
    {
      path: '/bazaar',
      name: 'Bazaar',
      component: resolve => require(['@/pages/bazaar/index'], resolve)
    },
    {
      path: '/bazaar/detail',
      name: 'BazaarDetail',
      component: resolve => require(['@/pages/bazaar/detail'], resolve)
    },
    {
      path: '/bazaar/pay',
      name: 'BazaarPay',
      component: resolve => require(['@/pages/bazaar/pay'], resolve)
    },
    {
      path: '/series',
      name: 'Series',
      component: resolve => require(['@/pages/series/index'], resolve)
    },
    {
      path: '/series/works',
      name: 'seriesWorks',
      component: resolve => require(['@/pages/series/works'], resolve)
    },
    {
      path: '/series/author',
      name: 'seriesAuthor',
      component: resolve => require(['@/pages/series/author'], resolve)
    },
    {
      path: '/news',
      name: 'News',
      component: resolve => require(['@/pages/news/index'], resolve)
    },
    {
      path: '/about',
      name: 'About',
      component: resolve => require(['@/pages/about'], resolve)
    },
    {
      path: '/user',
      name: 'User',
      component: resolve => require(['@/pages/user/index'], resolve)
    },
    {
      path: '/user/edit',
      name: 'UserEdit',
      component: resolve => require(['@/pages/user/edit'], resolve)
    },
    {
      path: '/user/nft',
      name: 'userNft',
      component: resolve => require(['@/pages/user/nft'], resolve)
    },
    {
      path: '/user/story',
      name: 'userStory',
      component: resolve => require(['@/pages/user/story'], resolve)
    },
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js